import { eventHasRun } from '../../utils/eventTracker';

export const DDC_LINK_GETDIRECTIONS = 'ddc.link.getDirections';

function getDirections({ currentTarget: element, timeStamp }) {
	let eventObject;
	const $element = $(element);

	if (
		!eventHasRun(DDC_LINK_GETDIRECTIONS, {
			timeStamp
		}) &&
		// Only track the event when the form has passed validation
		(!$element.data('validator') ||
			$element.data('validator').checkValidity())
	) {
		eventObject = {
			eventType: DDC_LINK_GETDIRECTIONS,
			eventData: {
				linkText: $element.find('button[type="submit"]').text().trim(),
				element
			}
		};
	}

	return eventObject;
}

export default getDirections;
